import { Vue, Component, Prop } from 'vue-property-decorator';
import {
  Getter,
  Action
} from 'vuex-class';
@Component({
  name: 'MobileShareVideoLayout',
  components: {
  }
})
export default class MobileShareVideoLayout extends Vue {
  @Getter('initMetaData') initMetaData?: string;
  @Getter('initData') initData?: Record<string, any>;
  @Getter('localLang') localLang?: Record<string, any>;
  @Getter('message') message?: Record<string, any>;

  isNode: boolean = EASY_ENV_IS_NODE;

  error: '';
  dir = 'ltr';

  created() {
    // const { result, error_msg, debug } = ctx.root.$route.query;
    this.$store.dispatch('getInitMetaData');
    this.$store.dispatch('getInitData');
    this.$store.dispatch('getLocalLang');
    const initPageData = this.initData;
    this.locale = initPageData?.locale || '';
    const message = initPageData?.message || { 'video-share': {} };
    this.error = this.localLang?.error || 'error';
  }
}